// @ai-generated 2026-10-08T12:37:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
import { type IHasTableModes } from '@Hooks/useTableModes';
import { SingleSelect, type ToolbarOptions } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

/** The toolbar of a table with the select that switches between its table modes. */
export function useContainerStockTableModeToolbar<TMode extends string>({
    tableModeValue,
    setTableMode,
    availableTableModes,
}: IHasTableModes<TMode>) {
    return useCallback(
        (elements: ToolbarOptions[]) => [
            ...elements,
            <SingleSelect<TMode>
                key="tableMode"
                name="tableMode"
                items={availableTableModes}
                value={tableModeValue}
                onChange={setTableMode}
            />,
        ],
        [setTableMode, availableTableModes, tableModeValue],
    );
}
